'use strict';

var $ = require('jquery');
var initialize = require('../core/initialize.js');

module.exports = function () {
    $(this).find('[data-tooltip-placements]').each(function () {
        var $container = $(this);
        var placement = $container.attr('data-tooltip-placements');
        $container.find('[data-toggle="tooltip"]').each(function () {
            $(this).attr('data-placement', placement);
        });
    });

    $(this).tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/tooltip.js
// module id = 502
// module chunks = 0